import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {
  AangifteSchenkbelasting,
  GiftTaxEntity,
  SbBerekening
} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormBuilder, FormGroup, ReactiveFormsModule} from "@angular/forms";
import {BokkzAlgDataService, BokkzSbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import {NgIf} from "@angular/common";
import {SharedUiDetailsModule} from "@snelstart/ui-details";
import {SharedUiFormControlsModule} from "@snelstart/ui-form-controls";
import {Subscription} from "rxjs";
import {SharedUiAlertModule} from "@snelstart/ui-alert";

@Component({
  selector: 'snelstart-venture-fiscaal-feature-berekening',
  standalone: true,
    imports: [
        NgIf,
        ReactiveFormsModule,
        SharedUiDetailsModule,
        SharedUiFormControlsModule,
        SharedUiAlertModule
    ],
  templateUrl: './berekening.component.html',
  styleUrl: './berekening.component.css'
})
export class BerekeningComponent implements OnInit, OnDestroy {

  @Input() public id!: string;
  @Input() public validaties: any;
  private giftTaxEntitySubscription: Subscription | undefined;
  private sbBerekeningSubscription: Subscription | undefined;
  public giftTaxEntity = {} as GiftTaxEntity;
  public sbAangifte = {} as AangifteSchenkbelasting;
  public sbBerekening = {} as SbBerekening;
  public sbBerekeningFg = {} as FormGroup;
  public focusedElementId: string | null = null;
  public hasContanten = false;
  public hasEffecten = false;
  public hasOnroerendeZaken = false;
  public hasOnderneming = false;
  public hasPU = false;
  public hasSchuldigerkenning = false;
  public hasKwijtschelding = false;
  public hasRoerendeZaken = false;
  public hasVruchtgebruiken = false;
  public hasOverige = false;
  public aantalValidatiesValue = {} as number;

  constructor(
    public algDataService: BokkzAlgDataService,
    public dataService: BokkzSbDataService,
    private fb: FormBuilder) {
    this.sbBerekeningFg = this.fb.group<SbBerekening>({
      totaalBedragContanten: null as unknown as number,
      totaalBedragEffecten: null as unknown as number,
      totaleWaardeGeschonkenOnroerendeZaken: null as unknown as number,
      totaalGeschonkenOndernemingsVermogen: null as unknown as number,
      totaalVrijgesteldOndernemingsVermogen: null as unknown as number,
      totaleWaardeGeschonkenApv: null as unknown as number,
      totaleWaardeGeschonkenPu: null as unknown as number,
      totaleWaardeGeschonkenRoerendeZaken: null as unknown as number,
      totaleWaardeSchuldigErkenning: null as unknown as number,
      totaleWaardeKwijtscheldingen: null as unknown as number,
      totaleWaardeVruchtgebruik: null as unknown as number,
      totaleWaardeOverigeSchenkingen: null as unknown as number,
      totaleSchenking: null as unknown as number,
      totaleVrijstellingen: null as unknown as number,
      eerderGebruikteVrijstellingen: null as unknown as number,
      benutteVrijstellingen: null as unknown as number,
      totaleVoorwaardelijkeVrijstelling: null as unknown as number,
      totaleBelastbareSchenking: null as unknown as number,
      grondslagEersteSchijf: null as unknown as number,
      grondslagTweedeSchijf: null as unknown as number,
      tariefEersteSchijf: null as unknown as number,
      tariefTweedeSchijf: null as unknown as number,
      belastingEersteSchijf: null as unknown as number,
      belastingTweedeSchijf: null as unknown as number,
      verhogingEersteSchijfVanwegeBrutering: null as unknown as number,
      verhogingTweedeSchijfVanwegeBrutering: null as unknown as number,
      totaalBelastingEersteSchijf: null as unknown as number,
      totaalBelastingTweedeSchijf: null as unknown as number,
      grondslagConserverendeAanslag: null as unknown as number,
    })
  }

  ngOnInit(): void {
    this.giftTaxEntitySubscription = this.dataService.giftTaxEntity.subscribe((value)=> {
      this.giftTaxEntity = value;
      this.sbAangifte = value.aangifte!;
      this.hasContanten = this.dataService.hasContanten.value;
      this.hasEffecten = this.dataService.hasEffecten.value;
      this.hasOnroerendeZaken = this.dataService.hasOnroerendeZaken.value;
      this.hasOnderneming = this.dataService.hasOnderneming.value;
      this.hasPU = this.dataService.hasPU.value;
      this.hasSchuldigerkenning = this.dataService.hasSchuldigerkenning.value;
      this.hasKwijtschelding = this.dataService.hasKwijtschelding.value;
      this.hasRoerendeZaken = this.dataService.hasRoerendeZaken.value;
      this.hasVruchtgebruiken = this.dataService.hasVruchtgebruiken.value;
      this.hasOverige = this.dataService.hasOverige.value;
    })
    this.sbBerekeningSubscription = this.dataService.sbBerekening.subscribe((value)=> {
      this.sbBerekening = value;
      this.sbBerekeningFg.patchValue(value,{emitEvent: false})
    })
    this.dataService.aantalValidaties.subscribe((value) => {
      this.aantalValidatiesValue = value;
    });
  }

  ngOnDestroy(): void {
    if (this.sbBerekeningSubscription) {
      this.sbBerekeningSubscription.unsubscribe()
    }
    if (this.giftTaxEntitySubscription) {
      this.giftTaxEntitySubscription.unsubscribe()
    }
  }

}
